<template>
<div>
  <div>
    <Multiselect
      v-bind:class="{'select-error': error.field, 'select--multi': !error.field}"
      v-model="selectField"
      :options="ruleFieldOption"
      track-by="name"
      label="name"
      placeholder="Select a Field"
      v-on:input="filterOperators">
    </Multiselect>
    <b-alert show class="error--gray" v-if="error && error.field"><i class="fas fa-exclamation-triangle"></i> {{error.field}}</b-alert>
    <Multiselect
      v-bind:class="{'select-error': error.operator, 'select--multi': !error.field}"
      v-model='selectOperator'
      :options="ruleOperators"
      track-by="name"
      label="name"
      placeholder="Select an Operator"
      v-on:input="setOperator">
    </Multiselect>
    <b-alert show class="error--gray" v-if="error && error.operator"><i class="fas fa-exclamation-triangle"></i> {{error.operator}}</b-alert>
    <input placeholder="Enter a Value" type="text" name="" :id="condition.condition_id" v-model='condition.value'>
  </div>
  <div class="flex flex-justify--end">
    <button class="ghost-button ghost-button--small" @click='deleteConfirm'><span class="x-icon"></span> Delete Conditition</button>
  </div>
  <ModalConfirm
    v-if="showModalConfirm"
    message="Are you sure you want to delete this condition? It cannot be undone."
    @confirm="deleteCondition()"
    @cancel="showModalConfirm = false"></ModalConfirm>
  </div>
</template>
<script>
import ModalConfirm from '@/components/ModalConfirm.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    ModalConfirm,
    Multiselect
  },
  props: {
    index: {
      type: Number
    },
    ruleObject: {
      type: String
    },
    ruleConnection: {
      type: Number
    },
    ruleFieldOption: {
      type: Array
    },
    condition: {
      type: Object
    },
    error: {
      type: Object,
      default: function () {
        return { 'field': '', 'operator': '' }
      }
    }
  },
  data () {
    return {
      showModalConfirm: false,
      ruleOperators: [
        { 'name': 'Does Not Equal' },
        { 'name': 'Greater Than' },
        { 'name': 'Less Than' },
        { 'name': 'Equals' },
        { 'name': 'Greater Than Or Equal To' },
        { 'name': 'Less Than Or Equal To' },
        { 'name': 'In' }
      ],
      simpleQuery: [],
      conditionNumber: '',
      selectField: { 'name': '', 'type': '' },
      selectOperator: { 'name': '' }
    }
  },
  mounted () {
    this.selectField.name = this.condition.field
    this.selectOperator.name = this.condition.operator
  },
  methods: {
    deleteConfirm () {
      this.conditionNumber = this.index + 1
      this.showModalConfirm = true
    },
    deleteCondition () {
      this.showModalConfirm = false
      this.$emit('deleteCondition', this.index)
    },
    filterOperators () {
      var fieldOptions = this.ruleFieldOption
      this.condition.field = this.selectField.name
      var type = fieldOptions.find(field => field.name === this.condition.field)
      switch (type.type) {
        case 'boolean':
          this.ruleOperators = [
            { 'name': 'Does Not Equal' },
            { 'name': 'Equals' }
          ]
          break
        case 'address':
        case 'email':
        case 'id':
        case 'phone':
        case 'picklist':
        case 'reference':
        case 'string':
        case 'textarea':
        case 'url':
          this.ruleOperators = [
            { 'name': 'Does Not Equal' },
            { 'name': 'Equals' },
            { 'name': 'In' }
          ]
          break
        case 'currency':
        case 'date':
        case 'datetime':
        case 'double':
        case 'int':
          this.ruleOperators = [
            { 'name': 'Does Not Equal' },
            { 'name': 'Greater Than' },
            { 'name': 'Less Than' },
            { 'name': 'Equals' },
            { 'name': 'Greater Than Or Equal To' },
            { 'name': 'Less Than Or Equal To' },
            { 'name': 'In' }
          ]
          break
        default:
          this.ruleOperators = [
            { 'name': 'Does Not Equal' },
            { 'name': 'Greater Than' },
            { 'name': 'Less Than' },
            { 'name': 'Equals' },
            { 'name': 'Greater Than Or Equal To' },
            { 'name': 'Less Than Or Equal To' },
            { 'name': 'In' }
          ]
      }
    },
    setOperator () {
      this.condition.operator = this.selectOperator.name
    }
  },
  updated () {
  }
}
</script>
